import { factory, stateOptions } from '@store/utils'
import { name } from '@utils/filters'

export default {
  auto: '*',

  store: {
    state: {
      signupEmail: null,
    },

    getters: {
      signupEmail: state => state.signupEmail,

      userFactory: factory(() => ({
        country: null,
        email: null,
        firstName: null,
        isSubscribed: true,
        lastName: null,
        password: null,
        role: 'USER',
      })),

      userOptions: stateOptions(name),
    },

    actions: {
      SIGNUP: async ({ dispatch }, user) =>
        dispatch('CREATE_USER', user),

      SET_SIGNUP_EMAIL({ commit }, signupEmail) {
        commit('SET_SIGNUP_EMAIL', signupEmail)
      },
    },

    mutations: {
      SET_SIGNUP_EMAIL: (state, signupEmail) => {
        state.signupEmail = signupEmail
      },
    },
  },
}
